export default __webpack_public_path__ + "static/media/2.aff1f142.md";